import BaseCrudRequests from "./BaseCrudRequests";

/**
 * ProjectShares model
 *
 * @param {ApiHelper} api
 */
export default class ProjectSharesRequests extends BaseCrudRequests {
    baseUrl = '/project-shares';

    constructor(api) {
        super(api);
    }


    async listForProject(projectId, errorHandler) {
        const url = this.baseUrl + '/' + projectId + '/list';

        const response = await this.api.getRequest(url);

        return this.processResponse(response, errorHandler);
    }


    async update(pk, data, errorHandler) {
        const url = this.baseUrl+'/' + pk;

        const response = await this.api.putRequest(url, data);

        return this.processResponse(response, errorHandler);
    }
}